import { render, staticRenderFns } from "./input-datepicker.vue?vue&type=template&id=08a958d2"
import script from "./input-datepicker.vue?vue&type=script&lang=js"
export * from "./input-datepicker.vue?vue&type=script&lang=js"
import style0 from "./input-datepicker.vue?vue&type=style&index=0&id=08a958d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../@coac/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports